import { TOptions } from "i18next";
import { TFunction } from "react-i18next";

/**
 * Interpolation values the API sends alongside an error code. The locale copy
 * decides which of them it uses — `{{line}}` and `{{row}}` for the upload
 * errors, `{{bank}}`, `{{maxAmount}}`, `{{remaining}}` and friends elsewhere.
 */
export type ErrorInterpolation = Record<string, string | number>;

export interface ApiError {
  code: number;
  additional?: ErrorInterpolation;
}

/**
 * Maps a list of API errors to their translated messages, falling back to the
 * generic `errors:unknown` copy when a code has no entry in the locale files.
 *
 * Per-error `additional` values take precedence over the shared
 * `additionalParams` passed by the caller.
 */
export function mapErrorCode(t: TFunction = null, errors: ApiError[] = [], additionalParams: TOptions = {}): string[] {
  if (!t || !Array.isArray(errors)) return [];

  return errors.map((error) =>
    t([`errors:${error.code}`, "errors:unknown"], { ...additionalParams, ...error.additional })
  );
}
